export default __webpack_public_path__ + "static/media/yunt.c87d6073.svg";